(function () {
  'use strict';

  angular.module('specsguardApp')
    .service('SocketService', SocketService);

  SocketService.$inject = ['$rootScope', '$location', '$log'];

  function SocketService ($rootScope, $location, $log) {

    /**
     * Auth listeners
     * */
    $rootScope.$on('loggedIn', function (event, token) {
      this.connect(token);
    }.bind(this));

    $rootScope.$on('loggedOut', function () {
      this.disconnect();
    }.bind(this));

    /**
     * SocketService variables
     * */
    this.socket = null;
    this.authenticated = false;

    /**
     * SocketService methods
     * */
    this.connect = (token, cb) => {
      // TODO: setup the socket service. It is disabled because the client service was going down 
      // when a ruimteblad page of a large project was openend.
      return false;
      if (!this.socket || !this.socket.connected) {
        let host = $location.host();
        const port = $location.port();

        // Used for E2E testing
        if (port === 11000 || port === 4200) {
          this.socket = io.connect('http://localhost:' + port, {path: '/realtime', reconnection: false});
        }
        else if (port !== 80 && port !== 443) {
          this.socket = io.connect('http://localhost:11019', {path: '/', reconnection: false});
        } else {
          this.socket = io.connect(host, {path: '/realtime', reconnection: false});
        }

        this.socket.on('connect', () => {
          this.socket
            .emit('authenticate', {token: token})
            .on('authenticated', () => {
              this.authenticated = true;
              if (cb) {
                cb(this.socket);
              }
            })
            .on('unauthorized', function (err) {
              $log.error(err);
            });
        });
      } else {
        if (this.socket && this.socket.connected && cb) {
          cb(this.socket);
        }
      }
    };

    this.disconnect = function () {
      if (this.socket) {
        this.socket.disconnect();
      }
    };

    this.connectToRoom = (room) => {
      if (this.authenticated) {
        this.socket.emit('joinRoom', room);
      }
    };

    this.disconnectFromRoom = (room) => {
      if (this.authenticated) {
        this.socket.emit('leaveRoom', room);
      }
    };

    /**
     * SocketService API
     * */
    return {
      connect: this.connect,
      disconnect: this.disconnect,
      authenticated: this.authenticated,
      connectToRoom: this.connectToRoom,
      disconnectFromRoom: this.disconnectFromRoom
    };
  }
})();
